export const zh_CN = {
    translation: {
        b: {
            cancel: '取消',
            confirm: '确认',
            send: '发送',
            done: '完成',
            close: '关闭',
            clear: '清除',
            copy_link: '复制链接',
            export: '导出',
            delete: '删除',
            delete_confirm: '确认删除',
            duplicate: '复制',
            share: '分享',
            sign_in: '登录',
            sign_up: '注册',
            email_address: '电子邮件地址',
            yes: '是',
            no: '否',
            back: '返回',
            upgrade: '升级',
            remove: '移除',
            restore: '恢复',
            archive: '归档',
            rename: '重命名',
            leave: '离开',
            import: '导入',
            continue: '继续',
            settings: '设置',
            log_out: '退出登录',
            invite: '邀请',
            invited: '已邀请',
        },
        roles: {
            view: '查看者',
            comment: '评论者',
            edit: '编辑者',
            admin: '管理员',
            owner: '所有者',
            member: '成员',
            remove: '移除',
            more_roles: '更多角色...',
            change_role: '更改角色...',
            remove_access: '移除访问权限...',
            remove_invite: '移除邀请...',
        },
        db_engine: {
            basic: '基础 SQL',
            general: '通用 SQL',
        },
        socket_status: {
            reconnecting: '正在重新连接...',
            offline: '你已离线，正在重新连接...',
        },
        loader: {
            diagram: '正在加载图表...',
        },
        m_languages: {
            title: '语言',
            subtitle: '选择一种语言'
        },
        m_feedback: {
            feature: {
                name: '功能请求',
                desc: '缺少你需要的功能？告诉我们——你的想法很重要'
            },
            feedback: {
                name: '分享你的反馈',
                desc: '我们很想听听你的想法'
            },
            support: {
                name: '支持',
                desc: '遇到问题了吗？告诉我们——我们会尽快为你解决',
            },
            bug: {
                name: '报告问题',
                desc: '发现了不对劲的地方？报告给我们——我们会尽快处理',
            },
            integration: {
                name: '请求集成',
                desc: '你的反馈对我们非常重要——请留下简短留言',
            },
        },
        m_feedback_t: {
            feature: {
                name: '感谢您的建议！',
                desc: '感谢您抽出时间分享想法——这有助于我们改进。'
            },
            feedback: {
                name: '感谢您的反馈！',
                desc: '感谢您抽出时间分享想法——这有助于我们改进。'
            },
            support: {
                name: '感谢您的联系！',
                desc: '感谢您联系支持团队——我们会尽快审核您的请求并给予回复。',
            },
            bug: {
                name: '感谢您的报告！',
                desc: '感谢您的报告——这有助于我们更快地修复问题并持续改进体验。',
            },
            contact: {
                name: '感谢您的联系！',
                desc: '我们已收到您的消息，会尽快回复。',
            },
            invite_people: {
                name: '邀请已成功发送！',
                desc: '感谢您帮忙传播——我们很期待欢迎他们的加入。',
            },
            integration: {
                name: '感谢您的建议！',
                desc: '感谢您抽出时间分享想法——这有助于我们改进。',
            },
        },
        m_diagram_details: {
            name_place: '输入项目名称',
            desc_place: '输入项目描述'
        },
        m_quick_share: {
            title: '快速分享',
            subtitle: '（基于查询的链接分享）'
        },
        m_export_img: {
            title: '导出图片'
        },
        search_menu: {
            placeholder: '搜索表、列、类型...',
            hint: '',
            no_results: '没有结果',
            quick_results: '快速搜索结果：',
            untitled: '未命名',
            command_tag: '命令',
            section_tables: '表',
            section_columns: '列',
            section_canvas: '画布',
            section_export: '导出',
            section_preferences: '偏好设置',
            section_settings: '设置',
            type_table: '表',
            type_note: '备注',
            cmd_new_table: '创建新表...',
            cmd_new_note: '创建新备注...',
            cmd_new_line: '创建新线...',
            cmd_new_area: '创建新区域...',
            cmd_export_image: '导出图片...',
            cmd_export_sql: '导出 SQL 代码...',
            cmd_grid_style: '更改网格布局...',
        },
        canvas_table: {
            more_column: '更多列',
            more_columns: '更多列',
            tooltip_table: '表',
            tooltip_indexes: '索引',
            tooltip_enum: '枚举',
            tooltip_default: '默认值',
            tooltip_generated: '生成值',
            tooltip_check: '检查约束',
        },
        m_export_code: {
            title: '导出 {{db_engine}} 代码',
            download_file: '下载文件',
            copy_code: '复制代码'
        },
        m_sign_in_remind: {
            title: '感谢尝试 DB Design',
            subtitle: '登录或注册以提高表数量上限、保存图表，并解锁更多功能。'
        },
        m_sign_in_restrict: {
            title: '登录以在应用中完成更多操作',
            subtitle: '登录或注册以提高表格上限、保存图表，并解锁更多功能。'
        },
        m_new_diagram: {
            title: '新建图表',
            subtitle: '选择数据库引擎',
            open_diagram: '打开图表',
            create_diagram: '创建图表',
            no_workspace: '请先创建一个工作区，才能开始创建图表。',
            build_something_new: '一起创造新事物吧',
            create_diagram_section: '创建图表',
            clone_template_btn: '克隆模板',
        },
        m_diagram_name: {
            enter_new_name: '输入新的图表名称',
        },
        m_diagram_clone: {
            header: '复制图表',
            copy_of_title: '{{title}} 的副本',
        },
        m_diagram_rename: {
            header: '重命名图表',
        },
        m_template_clone: {
            header: '从模板创建图表',
        },
        m_diagram_delete: {
            header: '删除图表',
            desc_prefix: '这将删除 ',
        },
        m_diagram_archive: {
            header: '归档图表',
            desc_prefix: '这将归档 ',
        },
        m_diagram_restore: {
            header: '恢复图表',
            desc_prefix: '这将恢复 ',
        },
        m_diagram_import: {
            sql_name: '导入 SQL 代码',
            dbml_name: '导入 DBML 代码',
            placeholder: '我们很想听听您的想法！',
        },
        m_diagram_not_found: {
            header: '未找到图表',
            desc: '我们找不到您要查找的图表。',
            back_to_app: '返回应用',
        },
        m_diagram_share: {
            header: '分享图表 – {{title}}',
            owner_only_invite: '只有所有者可以邀请新成员',
            invited_to_workspace: '已邀请加入工作区',
            you: '你',
            email_placeholder: '输入电子邮件',
            email_already_in_list: '该邮箱已在列表中',
            will_be_invited_to_workspace: '将被邀请加入工作区',
        },
        m_invite_people: {
            header: '邀请加入工作区',
        },
        m_invite_revoke: {
            header: '移除邀请',
            desc_prefix: '移除对以下用户的邀请：',
            desc_suffix: '该邀请将失效。',
        },
        m_member_remove: {
            header: '移除成员',
            desc_prefix: '移除 ',
            desc_suffix: '？此人将失去访问权限。',
        },
        m_template_details: {
            preview: '预览',
            use_template: '使用模板',
        },
        m_workspace_create: {
            header: '创建新工作区',
            name_label: '名称',
            setup_config_label: '设置配置',
            setup_config_value: '空工作区',
            template_structure_label: '模板 / 结构',
            template_structure_value: '预加载结构',
            placeholder: '输入工作区名称',
            create_button: '创建工作区',
            creating: '正在创建工作区...',
        },
        m_workspace_delete: {
            header: '删除工作区',
            desc_prefix: '这将永久删除 ',
            confirm_prefix: '请输入 ',
            confirm_suffix: ' 以确认。',
        },
        m_workspace_leave: {
            header: '离开工作区',
            desc_prefix: '这将把你从 ',
            desc_suffix: '中移除。若要重新加入，需要重新获得邀请。',
        },
        m_workspace_menu: {
            manage_members: '管理成员',
            switch_workspace: '切换工作区',
            workspaces_label: '工作区',
            create_workspace: '创建工作区...',
            switching: '正在切换',
        },
        m_profile_menu: {
            profile: '个人资料',
            onboarding: '新手引导',
        },
        m_pricing_limit: {
            admin_roles: { title: '让协作更上一层楼', description: '升级以解锁更多共享角色，如管理员、编辑者、评论者、查看者。' },
            workspaces: { title: '你正在快速成长！', description: '升级以创建和管理更多工作区，助力你的项目与团队。' },
            workspaces_canvas: { title: '扩展你的工作区', description: '升级以创建和管理更多工作区，助力你的项目与团队。' },
            members: { title: '大规模协作', description: '升级以邀请更多成员加入工作区，实现更高效的协作。' },
            diagrams: { title: '你正在快速成长！', description: '升级以创建更多图表，自信地推进你的项目。' },
            tables: { title: '无限制创建', description: '升级以添加更多表，继续构建更大、更详细的图表。' },
            columns: { title: '无限制创建', description: '升级以添加更多列，继续构建更大、更详细的图表。' },
            notes: { title: '无限制创建', description: '升级以添加更多便签，继续构建更大、更详细的图表。' },
            areas: { title: '无限制创建', description: '升级以添加更多区域，继续构建更大、更详细的图表。' },
            pens: { title: '无限制创建', description: '升级以添加更多绘图，继续构建更大、更详细的图表。' },
            default_title: '让协作更上一层楼',
            default_title_canvas: '让性能更上一层楼',
        },
        m_pricing_plans: {
            title: '升级你的方案',
            subtitle: '你可以随时升级或降级你的方案',
            monthly: '按月',
            annually: '按年',
            billed_annually: '按年计费',
            billed_monthly: '按月计费',
            free_for_everyone: '所有人免费',
            current_plan: '当前方案',
            will_be_available_soon: '即将推出',
            price_period_user_month: '/用户/月',
            plan_free: {
                name: '免费版',
                button: '更改方案',
                feature_realtime: '实时协作',
                feature_members: '每个工作区 4 名成员',
                feature_diagrams: '每个工作区 4 个图表',
                feature_tables: '每个图表 40 张表',
            },
            plan_pro: {
                name: 'Pro',
                feature_all_free: '包含免费版全部功能 +',
                feature_members: '成员数量不限',
                feature_diagrams: '图表数量不限',
                feature_tables: '表数量不限',
                feature_history: '版本历史',
                feature_admin_roles: '管理员角色',
            },
        },
        sidebar: {
            new: '新建',
            pinned_diagrams: '已置顶的图表',
            pin_hint: '置顶图表后会显示在这里',
            expand_sidebar: '展开侧边栏',
            home_aria: 'DB Design 主页',
            open_menu: '打开菜单',
            close_menu: '关闭菜单',
            sidebar_menu_aria: '侧边栏菜单',
            plan_suffix: '方案',
            diagram_options: '图表选项',
            pin: '置顶',
            unpin: '取消置顶',
            edit_details: '编辑详情',
            see_details: '查看详情',
            invite_people: '邀请',
            collapse_sidebar: '收起侧边栏',
            close_sidebar: '关闭侧边栏',
            open_sidebar: '打开侧边栏',
            open_new_tab: '在新标签页中打开',
        },
        focus_controls: {
            show_top: '显示顶部控件',
            hide_top: '隐藏顶部控件',
            show_left: '显示左侧控件',
            hide_left: '隐藏左侧控件',
        },
        m_keyboard_shortcuts: {
            title: '键盘快捷键',
            general: {
                title1: '常规',
                title2: '',
                items: {
                    new_diagram: '创建图表',
                    new_chat: '新建对话',
                    search: '快速操作或搜索',
                    preferences: '偏好设置',
                    settings: '设置',
                    keyboard_shortcuts: '键盘快捷键',
                    toggle_sidebar: '切换侧边栏',
                    toggle_theme: '切换主题',
                },
            },
            ctrl_left: {
                title1: '控件',
                title2: '(左侧)',
                items: {
                    mouse_sel: '鼠标选择 / 手形模式',
                    table: '表',
                    line: '线',
                    area: '区域',
                    note: '备注',
                    comment: '注释',
                    pen: '画笔',
                    undo: '撤销',
                    redo: '重做'
                },
            },
            ctrl_top_left: {
                title1: '控件',
                title2: '(左上角)',
                items: {
                    export_img: '导出图片',
                    search: '搜索',
                    editor_panel: '编辑器面板',
                    zoom_to_fit: '适配到屏幕',
                },
            },
            ctrl_bottom_right: {
                title1: '控件',
                title2: '(右下角)',
                items: {
                    minimap: '小地图',
                    full_screen: '全屏',
                    zoom_in: '放大',
                    zoom_out: '缩小',
                    zoom_100: '缩放至 100%'
                },
            },
            ctx_tab: {
                title1: '上下文菜单',
                title2: '(表)',
                items: {
                    dupl_tab: '复制表',
                    del_tab: '删除表'
                },
            },
            ctx_del_tab: {
                title1: '上下文菜单',
                title2: '(删除表)',
                items: {
                    yes: '是',
                    no: '否'
                },
            },
            ctx_tab_col: {
                title1: '上下文菜单',
                title2: '(表列)',
                items: {
                    add_col_below: '在下方添加列',
                    focus_col_above: '将焦点移至上一列',
                    focus_col_below: '将焦点移至下一列',
                    move_col_up: '上移列',
                    move_col_down: '下移列',
                    dupl_col: '复制列',
                    del_col: '删除列'
                },
            },
            ctx_line: {
                title1: '上下文菜单',
                title2: '(线)',
                items: {
                    del_line: '删除连线'
                },
            },
            ctx_area: {
                title1: '上下文菜单',
                title2: '(区域)',
                items: {
                    dupl_area: '复制区域',
                    del_area: '删除区域'
                },
            },
            ctx_multi: {
                title1: '上下文菜单',
                title2: '(多选)',
                items: {
                    select_all: '选择所有元素',
                    create_area_for_select_els: '为所选元素创建区域',
                    dupl_select_els: '复制所选元素',
                    del_select_els: '删除所选元素'
                },
            },
        },
        t: {
            ctrl_left: {
                mouse_select: '鼠标选择',
                table: '表',
                line: '线',
                area: '区域',
                note: '备注',
                comment: '注释',
                pen: '画笔',
                undo: '撤销',
                redo: '重做'
            },
            ctrl_top_left: {
                home: '主页',
                name: '图表信息',
                editor: '编辑器',
                search: '搜索',
                export: '导出选项',
                view_mode: '查看模式',
                zoom_to_fit: '适配到屏幕',
                grid: '网格布局',
                history: '历史记录',
                main_menu: '主菜单',
                new_diagram: '新建图表',
            },
            ctrl_top_right: {
                feature_req: '功能请求',
                feedback: '发送反馈',
                sign_in: '登录',
                quick_share: '快速分享'
            },
            ctrl_bottom_right: {
                full_screen: '全屏',
                minimap: '小地图',
                zoom_out: '缩小',
                zoom_100: '缩放至 100%',
                zoom_in: '放大',
                info: '信息与资源'
            },
            ctx: {
                base: {
                    colors: {
                        default: '默认',
                        blue: '蓝色',
                        green: '绿色',
                        red: '红色',
                        purple: '紫色',
                        violet: '紫罗兰色'
                    },
                    borders: {
                        none: '无',
                        solid: '实线',
                        dashed: '虚线',
                        dotted: '点线'
                    },
                    color: '颜色',
                    border: '边框',
                    description: '描述',
                    description_table_place: '表说明',
                    description_column_place: '列说明',
                    description_line_place: '连线说明',
                    description_note_place: '备注说明',
                    description_area_place: '区域说明',
                    description_pen_place: '画笔说明',
                    hide_menu: '隐藏菜单',
                    show_menu: '显示菜单'
                },
                tab_col: {
                    add_col_below: '在下方添加列',
                    add_col_above: '在上方添加列',
                    key: 'Key',
                    keys: {
                        none: '无',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: '无',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: '下移列',
                    move_col_up: '上移列',
                    more_functions: '更多功能'
                },
                line: {
                    change_connects: '修改连接器',
                    connects: {
                        empty: '空',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_many_to: 'One or Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: '过滤元素'
                },
                note: {
                    link_placeholder: '输入链接',
                    link_apply: '添加',
                    link_remove: '移除',
                    link_edit: '编辑',
                    link_needs_selection: '选择文本以添加链接',
                    bulleted_list: '列表',
                    numbered_list: '编号列表',
                    font_style: '字体样式',
                    alignment: '对齐方式',
                    align_left: '左对齐',
                    align_center: '居中对齐',
                    align_right: '右对齐',
                    link: '链接',
                    monospace: '等宽字体',
                    bold: '加粗',
                    italic: '斜体',
                    underline: '下划线',
                    strikethrough: '删除线',
                },
                multi: {
                    filter: '过滤所选内容',
                    create_area: '创建区域'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: '完整',
            keys_only: '仅键',
            names_only: '仅名称'
        },
        dropdown_ctrl_grid: {
            none: '无',
            lines: '线条',
            dots: '点',
        },
        dropdown_ctrl_export: {
            export_img: '导出图片',
            export_code: '导出 SQL 代码'
        },
        dropdown_ctrl_settings: {
            back_home: '返回主页',
            sign_in: '登录',
            preferences: '偏好设置',
            new_project: '新建项目',
            import_diagram: '导入图表',
            duplicate_diagram: '复制图表',
            keyboard_shortcuts: '键盘快捷键',
            languages: '语言',
            view: '视图',
            upgrade_plan: '升级方案',
            language: '语言',
            mouse_trackpad: '鼠标或触控板',
            background_color: '背景颜色',
            grid_layout: '网格布局',
            view_mode: '查看模式',
            show_align_lines: '显示对齐线',
            show_members_cursors: '显示成员光标',
            show_comments: '显示评论',
            undo_redo_controls: '撤销/重做控件',
            show_scrollbars: '显示滚动条',
            opt_auto: '自动',
            opt_trackpad: '触控板',
            opt_mouse: '鼠标',
            opt_default: '深色（默认）',
            opt_gray: '灰色',
            opt_blue: '蓝色',
            opt_purple: '紫色',
            opt_violet: '紫罗兰色',
            opt_green: '绿色',
            opt_red: '红色',
            opt_yellow: '黄色',
            opt_dots: '点',
            opt_lines: '线条',
            opt_none: '无',
            opt_full: '完整',
            opt_keys: '键',
            opt_names: '名称',
        },
        dropdown_ctrl_info_resources: {
            feedback: '反馈',
            keyboard_shortcuts: '键盘快捷键',
            languages: '语言',
            homepage: '主页'
        },
        n: {
            default: '加载中…',
            file_ready_to_download: '文件已准备好下载',
            code_copied: '代码已复制',
            link_copied: '链接已复制',
            username_copied: '用户名已复制',
            email_copied: '电子邮件已复制',
            please_enter_message: '请输入消息',
            invalid_email: '电子邮件地址无效',
            note_link_unsupported_protocol: '不支持此链接类型。请使用 https、http、mailto。',
            something_wrong_contact: '出错了。请尝试重新加载页面或联系我们。',
            something_wrong: '出错了。请尝试重新加载页面。',
            sending: '发送中…',
            request_sent: '请求已发送。谢谢!',

            please_enter_email: '请输入电子邮件地址',
            changing: '正在更改...',
            role_changed: '角色已更改',
            removing: '正在移除...',
            member_removed: '成员已移除',
            inviting: '正在邀请...',
            invite_sent: '邀请已发送',
            added_to_diagram: '已添加到图表',
            invite_removed: '邀请已移除',
            role_not_allowed_on_plan: '当前方案不支持该角色。升级后即可分配。',
            already_diagram_member: '此人已经可以访问该图表。',
            cannot_invite_to_workspace: '请让工作区管理员邀请此人加入工作区。',
            saving: '正在保存...',
            saved: '已保存',
            diagram_renamed: '图表已重命名',
            diagram_updated: '图表已更新',
            duplicating: '正在复制...',
            diagram_duplicated: '图表已复制',
            deleting: '正在删除...',
            diagram_archived: '图表已归档',
            diagram_deleted: '图表已删除',
            restoring: '正在恢复...',
            diagram_restored: '图表已恢复',
            diagram_pinned: '图表已置顶',
            diagram_unpinned: '图表已取消置顶',
            creating: '正在创建...',
            diagram_created: '图表已创建',
            forbidden: '你无权访问此内容。',
            invite_already_pending: '此人已有一个待处理的邀请。',
            already_member: '已是工作区成员',
            cannot_invite_self: '无法邀请自己',
            workspace_not_found: '未找到工作区。请刷新页面后重试。',
            diagram_not_found: '未找到图表。',
            has_diagram_members: '该图表有活跃成员',
            seat_limit_reached: '你已达到当前方案的席位上限。升级以邀请更多人。',
            feature_not_in_plan: '当前方案不包含此功能。',
            subscription_expired: '你的订阅已过期。请续订以继续使用。',
            subscription_inactive: '你的订阅未生效。请更新账单信息。',
            plan_limit_generic: '你的方案不支持此操作。升级后即可继续。',

            // Auth / profile
            session_expired: '你的会话已过期 — 请重新登录。',
            profile_updated: '个人资料已更新',
            profile_update_failed: '更新个人资料失败。',
            account_delete_failed: '删除账户失败。',

            // Preferences
            couldnt_save: '无法保存更改',
            try_again: '出错了，请重试。',

            // Workspace
            not_workspace_member: '你不是该工作区的成员。',
            workspace_switch_failed: '无法切换工作区，请重试。',
            workspace_create_failed: '无法创建工作区，请重试。',
            invalid_workspace_name: '工作区名称无效',
            workspace_updated: '工作区已更新',
            workspace_update_failed: '无法更新工作区，请重试。',
            last_owner_cannot_leave: '你是唯一的所有者。请先将其他人设为所有者，或删除该工作区，然后再离开。',
            workspace_leave_failed: '无法离开工作区，请重试。',
            workspace_delete_forbidden: '只有工作区所有者可以删除该工作区。',
            workspace_has_active_billing: '请先取消该工作区的订阅，再进行删除。',
            workspace_deleted: '工作区已删除',
            workspace_delete_failed: '无法删除工作区，请重试。',
            member_remove_forbidden: '你无权移除此成员。',
            member_remove_failed: '无法移除成员，请重试。',
            cannot_remove_self: '如需移除自己，请使用“离开工作区”。',
            cannot_remove_last_owner: '工作区必须始终有一位所有者。请先将其他人设为所有者。',
            invite_revoke_forbidden: '你无权撤销此邀请。',
            invite_revoke_failed: '无法撤销邀请，请重试。',
        },
        dashboard: {
            doc_title: '图表',
            filter_all: '全部',
            filter_mydiagrams: '我的图表',
            filter_shared: '与我共享',
            filter_archived: '已归档',
            empty_all: '"全部图表"中没有图表',
            empty_mydiagrams: '"我的图表"中没有图表',
            empty_shared: '"与我共享"中没有图表',
            empty_archived: '"已归档"中没有图表',
            example_diagram_badge: '示例图表',
            import_sql: 'SQL',
            import_dbml: 'DBML',
            import_playground: 'Playground',
        },
        settings_page: {
            nav: {
                back_to_app: '返回应用',
                group_personal: '个人',
                group_organization: '组织',
                billing: '账单',
            },
            profile: {
                member_since: '加入于 {{date}}',
                general: '常规',
                email: '邮箱',
                full_name: '姓名',
                full_name_placeholder: '输入姓名',
                account_protection: '账户保护',
                mfa_label: '多因素身份验证 (MFA)',
                mfa_sub: '为账户增加一层额外的安全保护 · 即将推出',
                mfa_enable: '启用 MFA',
                mfa_soon_tooltip: '即将推出',
                workspace_access: '工作区权限',
                leave_workspace: '离开工作区',
                leave_workspace_sub: '将你从工作区中移除',
                leave_owner_tooltip: '离开前请先转让所有权',
            },
            workspace: {
                header: '工作区',
                general: '常规',
                name_label: '工作区名称',
                name_placeholder: '工作区名称',
                stat_member_singular: '成员',
                stat_member_plural: '成员',
                stat_team_singular: '团队',
                stat_team_plural: '团队',
                members_section: '成员',
                no_members: '暂无成员',
                count_member_singular: '成员',
                count_member_plural: '成员',
                view_members_btn: '查看成员',
                danger_zone: '危险区域',
                delete_workspace: '删除工作区',
                delete_workspace_sub: '这将永久删除该工作区',
                delete_owner_only_tooltip: '只有所有者才能删除工作区',
                delete_cancel_sub_tooltip: '请先取消订阅，再删除工作区',
            },
            members: {
                header: '成员',
                col_name: '姓名',
                col_email: '邮箱',
                col_role: '角色',
                col_joined: '加入时间',
                active_members: '活跃成员',
                invited_section: '已邀请',
                no_members: '暂无成员。',
                options_aria: '选项',
                leave_workspace_item: '离开工作区…',
                remove_member_item: '移除成员…',
                remove_owner_only_tooltip: '只有所有者才能移除成员',
                remove_owner_row_tooltip: '无法将所有者移出工作区',
                remove_invite_item: '移除邀请…',
                role_invited_suffix: '{{role}}（已邀请）',
            },
            preferences: {
                section_general: '常规',
                section_diagram_defaults: '图表设置',
                section_diagram_views: '图表视图',
                section_notifications: '通知',
                theme_label: '界面主题',
                theme_sub: '选择界面配色方案',
                theme_dark: '深色',
                theme_light: '浅色',
                theme_system: '跟随系统',
                language_sub: '选择界面语言',
                timezone_label: '时区',
                timezone_sub: '选择你的时区',
                timezone_options: {
                    honolulu: 'GMT-10:00 — 夏威夷',
                    anchorage: 'GMT-09:00 — 阿拉斯加',
                    los_angeles: 'GMT-08:00 — 太平洋时间',
                    denver: 'GMT-07:00 — 山地时间',
                    chicago: 'GMT-06:00 — 中部时间',
                    new_york: 'GMT-05:00 — 东部时间',
                    caracas: 'GMT-04:00 — 加拉加斯',
                    sao_paulo: 'GMT-03:00 — 圣保罗',
                    azores: 'GMT-01:00 — 亚速尔群岛',
                    london: 'GMT+00:00 — 伦敦',
                    paris: 'GMT+01:00 — 巴黎、柏林',
                    kyiv: 'GMT+02:00 — 基辅、雅典',
                    istanbul: 'GMT+03:00 — 伊斯坦布尔',
                    dubai: 'GMT+04:00 — 迪拜',
                    karachi: 'GMT+05:00 — 卡拉奇',
                    kolkata: 'GMT+05:30 — 印度',
                    dhaka: 'GMT+06:00 — 达卡',
                    bangkok: 'GMT+07:00 — 曼谷、雅加达',
                    shanghai: 'GMT+08:00 — 北京、新加坡',
                    tokyo: 'GMT+09:00 — 东京、首尔',
                    sydney: 'GMT+10:00 — 悉尼',
                    auckland: 'GMT+12:00 — 奥克兰',
                },
                input_mode_sub: '选择画布导航控制方式',
                background_sub: '为画布选择背景颜色',
                grid_sub: '选择画布网格布局',
                show_align_lines_sub: '对齐对象时显示辅助线',
                show_cursors_sub: '显示其他协作者的光标',
                show_comments_sub: '在画布上显示评论',
                show_scrollbars_sub: '浏览画布时显示滚动条',
                show_undo_redo_label: '显示撤销/重做控件',
                show_undo_redo_sub: '显示用于撤销和重做更改的控件',
                notif_shared_label: '与我共享的图表',
                notif_shared_sub: '当有人与我共享图表时',
                notif_mentions_label: '评论中的提及',
                notif_mentions_sub: '当有人在评论中 @提及我时',
                notif_updates_label: '产品更新',
                notif_updates_sub: '关于新功能和改进的月度更新',
                show: '显示',
                hide: '隐藏',
                on: '开',
                off: '关',
            },
            billing: {
                header: '账单',
                plan_free: '免费方案',
                status_current: '当前',
                no_renewal_needed: '无需续订',
                payment_header: '付款',
                no_payments: '暂无付款',
                invoices_header: '发票',
                no_invoices: '暂无发票',
            },
            usage: {
                doc_title: '用量',
                overview_title: '概览',
                resource_limits_title: '资源限制',
                label_diagrams: '图表',
                label_tables: '数据表',
                label_areas: '区域',
                label_notes: '便签',
                label_members: '成员',
                label_tables_per_diagram: '数据表 / 图表',
                label_areas_per_diagram: '区域 / 图表',
                label_notes_per_diagram: '便签 / 图表',
                need_more_title: '需要更多？',
                need_more_free: '升级到 Basic 版，获得更多图表、版本历史记录和优先支持。',
                need_more_paid: '升级到 Professional 版，获得无限图表、席位和高级功能。',
            },
        },
        pages: {
            not_found: {
                page_not_found: '未找到页面',
                dont_have_access_to_diagram: '你无权访问此图表，或该图表已不存在。',
                back_home: '返回主页'
            },
            error: {
                title: '错误',
                link_is_invalid: '此链接无效或输入有误。',
                something_wrong: '出错了。',
                back_home: '返回主页',
                please_try_later: '请稍后再试',
            },
            billing_success: {
                doc_title: '方案已升级',
                heading: '付款成功',
                subtitle: '您的方案已成功升级。',
                cta: '开始设计',
            },
            email_verified: {
                doc_title: '邮箱已验证',
            },
            forgot_password: {
                doc_title: '忘记密码',
            },
            password_updated: {
                doc_title: '密码已更新',
            },
            reset_password: {
                doc_title: '重置密码',
            },
            check_email: {
                doc_title: '请查看您的邮箱',
            },
            sign_in: {
                doc_title: '登录 {{product}}',
            },
            sign_up: {
                doc_title: '注册 {{product}}',
            },
        },
    },
};

export const zh_CNMeta = {
    lang_origin: '简体中文',
    lang_eng: 'Simplified Chinese',
    lang_code: 'zh-CN',
};
